import styles from "./collapsibleEvent.module.css"

export default function CollapsibleEvent({title, startDate, endDate, children, uri}){
    startDate.setMonth(startDate.getMonth());
    return (
      <div className={styles.container}>
          <hr size="1" width="100%"/>
          <button className={styles.title} onClick={() => toggleCollapse(title)}>{startDate.toLocaleString('de-DE', {month: 'short'})} <span className={styles.date}>{getDateString(startDate,endDate)}</span> {title} <span id={`indicator-${title}`} className={styles.indicator}/></button>
          <div id={`collapsible-${title}`} className={styles.content}>
              {children}
              <p><a  className="underline" href={uri}>Hier geht's zum Veranstalter</a></p>
          </div>
      </div>
    );
}

function toggleCollapse(id) {
    let content = document.getElementById(`collapsible-${id}`);
    let indicator = document.getElementById(`indicator-${id}`);

    if(content.classList.contains(styles.showContent))
    {
        content.classList.remove(styles.showContent);
        indicator.classList.remove(styles.open);
    }else{
        content.classList.add(styles.showContent);
        indicator.classList.add(styles.open);
    }
}

function getDateString(startDate, endDate){
    startDate.setMonth(startDate.getMonth() + 1);
    endDate.setMonth(endDate.getMonth() + 1);
    if(startDate.getDate() === endDate.getDate()){
        
        return startDate.getDate() + "." + startDate.getMonth();
    }
    return startDate.getDate() + "." + startDate.getMonth() +" - " + endDate.getDate() + "." + endDate.getMonth();
}